import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  Output,
  EventEmitter
} from "@angular/core";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { MatAutocomplete, MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { MatSnackBar } from "@angular/material/snack-bar";
import { FormControl } from "@angular/forms";
import { Subject } from "rxjs";
import { debounceTime } from 'rxjs/internal/operators/debounceTime';
import { distinctUntilChanged } from 'rxjs/operators';
import { MatChipInputEvent } from '@angular/material/chips';

@Component({
  selector: "app-chip",
  templateUrl: "./chip.component.html",
  styleUrls: ["./chip.component.css"]
})
export class ChipComponent implements OnInit {

  constructor(
    private toolTip: MatSnackBar,
  ) {
    this.autoUpdate
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe(value => {
        this.valueChange.emit(value);
      });
  }

  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  inputValue = new FormControl();
  autoUpdate = new Subject<string>();

  @ViewChild("input") productInput: ElementRef<HTMLInputElement>;
  @ViewChild("auto") matAutocomplete: MatAutocomplete;

  @Input() options: any;
  @Input() placeholder: any;
  @Input() chips: any[];
  @Input() key: string;

  @Output() valueChange = new EventEmitter();
  @Output() finalValue = new EventEmitter();

  ngOnInit() { }

  valueChanged() {
    this.finalValue.emit(this.chips);
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    console.log(this.chips);

    // Add our item
    if ((value || "").trim()) {
      // this.chips.push(value.trim());
      console.log(value);
    }

    // Reset the input value
    if (input) {
      input.value = "";
    }

    this.inputValue.setValue(null);
  }

  remove(c: string): void {
    const index = this.chips.indexOf(c);

    if (index >= 0) {
      this.chips.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const index = this.chips.findIndex((e: any) => {
      return e.pid === event.option.value.pid;
    });

    if (index < 0) {
      this.chips.push(event.option.value);
      this.productInput.nativeElement.value = "";
      this.inputValue.setValue(null);
      this.finalValue.emit(this.chips);
    } else {
      this.toolTip.open(event.option.value['Product Title'] + ' Alredy exist on chips', 'Ok', { duration: 3000 });
    }
  }

  displayFn(id) {
    if (!id) {
      return "";
    }
    return id[this.key];
  }

}
